import { render, staticRenderFns } from "./ItemBase.vue?vue&type=template&id=6a357869&"
import script from "./ItemBase.vue?vue&type=script&lang=js&"
export * from "./ItemBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports